// extracted by mini-css-extract-plugin
export var dataCell = "_r0-2";
export var dataRow = "_r0-0";
export var headerRow = "_r0-1";